










import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
    name: 'BaseInputColor',
})
export default class BaseInputColor extends Vue {
    @Prop() hex!: string;

    get color(): string {
        return this.hex || Math.floor(Math.random() * 16777215).toString(16);
    }

    set color(color: string) {
        this.$emit('update:color', color);
    }

    changeColor() {
        this.color = '#' + Math.floor(Math.random() * 16777215).toString(16);
    }
}
